/**
 * createCampaignRepository
 * @param dataWrapper {ReturnType<import('core/data/data-wrapper')._DB>}
 */
export function createDistributorGroupRepository(dataWrapper) {
  const { list } = dataWrapper
  const DOCUMENT_KEY = 'distributor-group'

  const _listDistributorGroups = (list) => list(DOCUMENT_KEY)

  const listDistributorGroups = () => _listDistributorGroups(list)

  return {
    _listDistributorGroups,
    listDistributorGroups,
  }
}
